import s from "./ContactDetails.module.scss";
import clsx from "clsx";
import { useQuery } from "../../../../../../../libs/common";
import useSWR from "swr";
import { UseAuthToken } from "../../../../../../../libs/api/userSession";
import {
  parseClientError,
  swrFetcher,
} from "../../../../../../../libs/api/Endpoints";

import ContactAvatar from "../../../../../../../global components/Icons/ContactAvatar/ContactAvatar";
import { message } from "antd";
import { UserProfile } from "../../../../../../../libs/Utils/Types/User";
import { ThreeDots } from "react-loader-spinner";
function UserDetails() {
  const query = useQuery();

  const userId = query.get("userId");
  const token = UseAuthToken();
  const { data, isLoading, error } = useSWR<{ data: UserProfile }, any, any>(
    token ? [`api/admin/users/${userId}`, token] : null,
    swrFetcher,

    {
      revalidateOnFocus: true, // Refetch when the window regains focus
      // Refetch every 10 seconds (10000 ms)
      shouldRetryOnError: false, // Disable retrying on errors
    },
  );
  if (error) {
    const e = parseClientError(error);
    message.error(e.message || "User profile failed to load");
  }
  return (
    <>
      <div className={s.wrapper}>
        <div className={s.mainWrapper}>
          {isLoading || error ? (
            <div className={s.spin}>
              <ThreeDots
                visible={true}
                height="50"
                width="50"
                color="#d52b1e"
                radius="9"
                ariaLabel="three-dots-loading"
                wrapperStyle={{
                  dispaly: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  width: "100%",
                }}
                wrapperClass=""
              />
            </div>
          ) : (
            <section className={s.contactDetails}>
              <div className={s.profileDetails}>
                {data?.data.avatar ? (
                  <div className={s.imageContainer}>
                    <img
                      src={data.data.avatar} // Fallback to default profile image if no avatar
                      className={s.profilePics}
                      alt="Profile"
                    />
                  </div>
                ) : (
                  <ContactAvatar width={80} height={80} />
                )}
                <span className={s.name}>
                  <h2>
                    {data && (data?.data.firstName || data.data.lastName)
                      ? (data?.data.firstName
                          ? data?.data.firstName.charAt(0).toUpperCase() +
                            data?.data.firstName.slice(1)
                          : "N/A") +
                        " " +
                        (data?.data.lastName
                          ? data?.data.lastName.charAt(0).toUpperCase() +
                            data?.data.lastName.slice(1)
                          : "N/A")
                      : "N/A"}
                  </h2>
                  <h3
                    className={clsx(
                      s.verStatus,
                      s.statusCell,
                      data?.data.verificationStatus === "verified"
                        ? s.successful
                        : data?.data.verificationStatus === "unverified"
                          ? s.failed
                          : s.pending,
                    )}
                  >
                    {data?.data.verificationStatus}
                  </h3>
                </span>
              </div>
              <table className={s.table}>
                <tr>
                  <td className={s.tableLabel}>First name</td>
                  <td className={clsx(s.tableLabel, s.tableData)}>
                    {data?.data.firstName ? data?.data.firstName : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className={s.tableLabel}>Last name</td>
                  <td className={clsx(s.tableLabel, s.tableData)}>
                    {data?.data.lastName ? data?.data.lastName : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className={s.tableLabel}>Email address</td>
                  <td className={clsx(s.tableLabel, s.tableData)}>
                    {data?.data.email ? data?.data.email : "No email found"}
                  </td>
                </tr>
                <tr>
                  <td className={s.tableLabel}>Phone number</td>
                  <td className={clsx(s.tableLabel, s.tableData)}>
                    {data?.data.phoneNo ? data?.data.phoneNo : "No phone number found"}
                  </td>
                </tr>
              </table>
            </section>
          )}
        </div>
      </div>
    </>
  );
}

export default UserDetails;
